<template id="TicketFutbol">
  <div class="f-ticket">
    <div class="f-ticket__qr">
      <div class="f-ticket__qr_imgs">
        <img
          height="40"
          src="https://s3.us-west-2.amazonaws.com/joinnus.com/files/joinnus-com-logo.svg"
          alt="jn"
          class="hidden"
        />
        <div class="f-ticket__qr_qr">
          <span style="font-size: 10px">{{ item.code_bar }}</span>
          <img
            width="110"
            :src="'https://qr.joinnus.com/qr.png?size=130&body=' + item.code"
            alt="qr"
          />
          <p style="font-size: 10px">{{ item.code }}</p>
        </div>
      </div>
      <div class="f-ticket__qr_vs">
        <strong
          >{{ metadata.vs.teamPrimary.nameSmall }} <small>vs</small>
          {{ metadata.vs.teamSecond.nameSmall }}</strong
        >
        <b>{{ metadata.stadium }}</b
        ><br />
        <span>{{ metadata.dateStart }}</span>
      </div>
      <div class="f-ticket__qr_tribuna">
        <div>
         <small>Tribuna</small>
          <!-- <span>{{ item.mini_tribuna || item.tribuna }}</span> -->
          <span>{{ shortText(item.tribuna) }}</span>
        </div>
        <!-- <div v-if="item.puerta" class="tline">
          <small>Pta.</small>
          <span>{{ item.puerta }}</span>
        </div> -->
      </div>
      <div class="f-ticket__qr_sector">
        <span v-if="item.sector">Sector</span
        ><b v-if="item.sector">{{ item.sector }}</b>
        <span v-if="item.fila">Fila</span
        ><b v-if="item.fila">{{ item.fila }}</b>
        <span v-if="item.asiento">Asiento</span
        ><b v-if="item.asiento">{{ item.asiento }}</b>
        <span>&nbsp;</span>
      </div>
      <div class="f-ticket__qr_info">
        <b>*Recuerda</b>
        tu código QR es lo más importante de tu entrada Joinnus. Cuídalo como
        oro, no lo publiques y no lo compartas con nadie.
      </div>
    </div>
    <div class="f-ticket__body">
      <span class="f-ticket__body_ruc">
        {{ metadata.ruc }}
      </span>
      <small class="f-ticket__body_sure">
        Conserve su ticket. {{ metadata.poliza }}
      </small>
      <div class="f-ticket__body_content">
        <div class="f-ticket__body_head">
          <div class="f-ticket__body_stadium">
            <b>{{item.address}}</b>
          </div>
          <div class="f-ticket__body_date">
            <!--             <div class="ft-upper hidden">
              <b>{{ metadata.dateStart }}</b>
            </div> -->
            <div v-if="item.precio > 0">
              <div style="text-transform: uppercase;">
              <b>{{item.day}} {{getFormatMonth(item.dateStart)}} {{item.year}} | {{item.hour}}</b>
            </div>
              <b style="font-size: 12px;">{{ metadata.currency }} {{ item.precio }}</b>
            </div>
            <div v-else>
              <b>Cortesía</b>
            </div>
          </div>
        </div>
        <div v-if="!metadata.championship" class="f-ticket__body_vs">
          <div class="f-ticket-vs">
            <div class="f-ticket-vs__head">
              <b>{{ metadata.tourney }}</b>
            </div>
            <div class="f-ticket-vs__body">
              <img height="50" :src="metadata.vs.teamPrimary.logoUrl" alt="teamLogo" v-if="metadata.vs.teamPrimary.logoUrl">
              <div class="f-ticket-vs__vs">
                  <div>
                    {{ metadata.vs.teamPrimary.name1 }} <br>
                    <span v-html=" metadata.vs.teamPrimary.name2"></span>
                  </div>
                  <b v-if="metadata.vs.teamSecond.name1">VS</b>
                  <div v-if="metadata.vs.teamSecond.name1">
                      {{ metadata.vs.teamSecond.name1 }} <br>
                      {{ metadata.vs.teamSecond.name2 }}
                  </div>
              </div>
              <img height="50" :src="metadata.vs.teamSecond.logoUrl" alt="teamLogo" v-if="metadata.vs.teamSecond.logoUrl">
            </div>
          </div>
        </div>
        <div v-if="!metadata.championship" class="f-ticket__body_tribune">
          <div style="width: 100%">
            <div>Tribuna <b>{{ !(item.name && item.name.trim()) && item.document == '00000000' ? item.tribuna :  shortText(item.tribuna) }}</b></div>
            <!-- <div v-if="item.puerta">Puerta de ingreso <b>{{ item.puerta }}</b></div> -->
            <div><b>{{ item.username }}</b></div>
            <div v-if="item.document !== '00000000'">
              {{ item.docType ? item.docType : 'DNI' }} <b>{{ item.document }}</b>
            </div>
          </div>
          <div class="ft-body-sector" style="max-width: 25%">
            <div v-if="item.sector"><span>Sector</span> <b>{{ item.sector }}</b></div>
            <div v-if="item.fila"><span>Fila</span> <b>{{ item.fila }}</b></div>
            <div v-if="item.asiento"><span>Asiento</span> <b>{{ item.asiento }}</b></div>
          </div>
        </div>
        <div v-if="metadata.championship" class="f-ticket__body_tribune">
          <div style="max-width: 43%; width: 100%">
            <div class="f-ticket-vs__logo-copa">
              <img
                v-if="metadata.championship"
                height="110"
                :src="metadata.championship"
                alt="jn"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="ft-body-sector">
            <div class="f-ticket-vs__vs">
              <div v-if="metadata.vs.teamPrimary.name1">
                <img
                  height="50"
                  :src="metadata.vs.teamPrimary.logoUrl"
                  alt="teamLogo"
                  v-if="metadata.vs.teamPrimary.logoUrl"
                />
                <div v-else class="f-ticket-vs__logo-default">
                  {{ metadata.vs.teamPrimary.nameSmall }}
                </div>
                <div>
                  {{ metadata.vs.teamPrimary.name1 }} <br />
                  <span v-html="metadata.vs.teamPrimary.name2"></span>
                </div>
              </div>
              <b v-if="metadata.vs.teamSecond.name1">VS</b>
              <div v-if="metadata.vs.teamSecond.name1">
                <img
                  height="50"
                  :src="metadata.vs.teamSecond.logoUrl"
                  alt="teamLogo"
                  v-if="metadata.vs.teamSecond.logoUrl"
                />
                <div v-else class="f-ticket-vs__logo-default">
                  {{ metadata.vs.teamSecond.nameSmall }}
                </div>
                <div>
                  {{ metadata.vs.teamSecond.name1 }} <br />
                  <span v-html="metadata.vs.teamSecond.name2"></span>
                </div>
              </div>
            </div>
            <div style="overflow: hidden; height: 16px; margin-top: 10px">
              Tribuna <b>{{ shortText(item.tribuna) }}</b>
            </div>
            <div>
              <div v-if="item.sector">
                <span>Sector</span> <b>{{ item.sector }}</b>
              </div>
              <div v-if="item.fila">
                <span>Fila</span> <b>{{ item.fila }}</b>
              </div>
              <div v-if="item.asiento">
                <span>Asiento</span> <b>{{ item.asiento }}</b>
              </div>
            </div>
            <!-- <div v-if="item.puerta">
              Puerta de ingreso <b>{{ item.puerta }}</b>
            </div> -->
            <div v-if="item.precio > 0">
              <span>Precio</span>
              <b>{{ metadata.currency }} {{ item.precio }}</b> 
            </div>
            <div v-else>Cortesía</div>
          </div>
        </div>
        <div
          v-if="metadata.championship"
          class="f-ticket__body_tribune"
        >
          <div style="max-width: 43%; width: 100%">
            <div>
              <b>{{ item.username }}</b>
            </div>
            <div v-if="item.document !== '00000000'">
              {{ item.docType ? item.docType : "DNI" }}
              <b>{{ item.document }}</b>
            </div>
          </div>
          <div class="ft-body-sector">
          </div>
        </div>
      </div>
      <div class="f-ticket__body_logos hidden-">
        <div>
          <img
            v-for="(url, index) in metadata.sponsors"
            :src="url"
            height="18"
            alt="jn"
            :key="index"
          />
        </div>
        <div>
          <img
            class="ft-jn hidden"
            src="https://s3.us-west-2.amazonaws.com/joinnus.com/files/joinnus-com-logo.svg"
            height="40"
            alt="jn"
          />
        </div>
      </div>
    </div>
    <div class="f-ticket__info">
      <div class="f-ticket__info_body">
        <div class="f-ticket__info_tribuna">
          <div>
            <div>Tribuna</div>
            <div class="tribunaLg">
              <!-- {{ item.mini_tribuna || item.tribuna }} -->
              {{ shortText(item.tribuna) }}
            </div>
          </div>
          <!-- <div v-if="item.puerta">
            <div>Pta.</div>
            <div class="tribunaLg">
              {{ item.puerta }}
            </div>
          </div> -->
          <div v-if="item.sector">
            <div>Sector</div>
            <div class="tribunaLg">
              {{ item.sector }}
            </div>
          </div>
          <div v-if="item.fila">
            <div>Fila</div>
            <div class="tribunaLg">
              {{ item.fila }}
            </div>
          </div>
          <div v-if="item.asiento">
            <div>Asiento</div>
            <div class="tribunaLg">
              {{ item.asiento }}
            </div>
          </div>
        </div>
        <div class="f-ticket__info_footer">
          <div class="f-ticket__info_vs">
            <div>
              <strong
                >{{ metadata.vs.teamPrimary.nameSmall }} <small>VS</small>
                {{ metadata.vs.teamSecond.nameSmall }}</strong
              >
            </div>
            <div class="f-ticket__info_stadium">
              {{ metadata.stadium }}
              <span>
                {{ metadata.dateStart }}
              </span>
            </div>
          </div>
          <div class="f-ticket__info_price">
            <div v-if="item.precio > 0">
              <small>Precio</small>
              {{ metadata.currency }} {{ item.precio }}
            </div>
            <div v-else>Cortesía</div>
          </div>
        </div>
      </div>
    </div>
    <div class="f-ticket__barcode">
      <div class="f-ticket__barcode_body">
        <div class="f-ticket__barcode_head">
          <div class="f-ticket__barcode_data">
            {{ item.username }}
            <br />
            <span v-if="item.document !== '00000000'"
              >{{ item.docType ? item.docType : "DNI" }}:
              {{ item.document }}</span
            >
            <span>&nbsp;</span>
          </div>
          <div class="f-ticket__barcode_price">
            <div v-if="item.precio > 0">
              <small>Precio</small>
              {{ metadata.currency }} {{ item.precio }}
            </div>
            <div v-else>Cortesía</div>
          </div>
        </div>
        <div class="f-ticket__barcode_footer">
          <div style="white-space: nowrap; overflow: hidden; max-width: 130px">
            <small>Tribuna</small>
            <!-- {{ item.mini_tribuna || item.tribuna }} -->
            {{ shortText(item.tribuna) }}
          </div>
          <!-- <div v-if="item.puerta">
            <small>Pta.</small>
            {{ item.puerta }}
          </div> -->
          <div>
            <img
              :src="
                'https://www.joinnus.com/activity/ticket/' +
                (item.code_bar ? item.code_bar : item.code) +
                '/barcode?t=2&h=20'
              "
              alt="barcode1"
              height="20"
              width="130"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Setiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

const getFieldMeta = (key, item) => {
  const meta = item.metadata.find((el) => el.key === key)
  return meta ? meta.charValue : null
}

const generateMetadata = (item) => {
  const obj = {}

  obj.currency = item.currency === 'PEN' ? 'S/' : '$'
  obj.dateStart = `${item.day} ${months[item.month - 1]} ${item.year} - ${item.hour}`
  obj.stadium = item.addressRef
  obj.stadiumAddress = item.address

  obj.ruc = getFieldMeta('sport_ticket_ruc', item)
  obj.poliza = getFieldMeta('sport_ticket_policy', item)
  obj.tourney = getFieldMeta('sport_ticket_championship', item)
  obj.vs = JSON.parse(getFieldMeta('sport_ticket_vs', item))
  obj.sponsors = JSON.parse(getFieldMeta('sport_ticket_sponsors', item))
  obj.championship = getFieldMeta('logo_championship', item)

  return obj
}

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    metadata () {
      return generateMetadata(this.item)
    },
  },
  methods: {
    getFormatMonth(date) {      
      const months = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ]
      let month = new Date(date);
      let monthFormat = month.getMonth();
      return months[monthFormat];
    },
    shortText(text, nCaracter = 18) {
      return text ? text.slice(0, nCaracter) : '';
    }
  }
}
</script>

<style scoped>
  body {
    margin: 0;
  }

  .f-ticket {
    line-height: normal;
  }

  img {
    vertical-align: initial !important;
  }

  small {
    font-size: smaller;
    font-weight: inherit;
  }

  .hidden {
    visibility: hidden;
  }

  .btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
  }

  .text-center {
    text-align: center;
  }

  .btn-round {
  border-radius: 50px !important;
  }

  .f-ticket-vs__head {
    text-transform: uppercase;
    font-size: 11px;
    margin-bottom: 2px;
  }
  .f-ticket-vs__body {
    display: flex;
    align-items: center;
    padding: 5px 2px;
    border-top: 3px solid #000;
    border-bottom: 3px solid #000;
    margin-bottom: 10px;
  }
  .f-ticket-vs__vs {
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
    padding-left: 5px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .f-ticket-vs__vs b {
    padding: 7px;
    font-size: 140%;
  }
  .f-ticket-vs__logo-default{
    width: 40px;
    height: 40px;
    border: 1px solid;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    margin: 5px auto;
  }
  .ft-body-sector {
    display: table;
    max-width: 55%;
    width: 100%;
  }
  .ft-body-sector > div {
    /* width: 80px; */
    display: flex;
    justify-content: space-between;
    text-align: center;
  }

  .f-ticket {
    font-family: sans-serif;
    margin: 3px auto;
    width: 785px;
    height: 305px;
    background: #eee;
    border-radius: 10px;
    display: flex;
    position: relative;
    zoom: 1.1;
    /* page-break-after: always; */
  }
  .f-ticket:before {
    content: "";
    position: absolute;
    top: 15px;
    left: 170px;
    width: 440px;
    height: 7px;
    background: red;
    z-index: 1;
  }
  .f-ticket:after {
    content: "";
    position: absolute;
    top: 10px;
    left: 195px;
    width: 525px;
    height: 285px;
    background: rgba(0, 0, 0, 0.1);
  }
  .f-ticket * {
    box-sizing: border-box;
  }
  .f-ticket .ft-upper {
    text-transform: uppercase;
  }
  .f-ticket__qr {
    width: 185px;
    flex-shrink: 0;
    padding: 10px;
  }
  .f-ticket__qr_imgs {
    text-align: center;
    padding: 3px 0 7px;
  }
  .f-ticket__qr_qr {
    margin-top: -3px;
    position: relative;
  }
  .f-ticket__qr_qr p{
    margin-top: -3px;
    margin-bottom: 0;
  }
  .f-ticket__qr_qr span {
    font-size: 12px;
    display: block;
    width: 110px;
    position: absolute;
    bottom: 5px;
    left: 0;
    -webkit-transform-origin: left bottom;
            transform-origin: left bottom;
    -webkit-transform: rotate(-90deg) translateY(15px);
            transform: rotate(-90deg) translateY(15px);
  }
  .f-ticket__qr_vs {
    margin-top: -3px;
    text-transform: uppercase;
    font-size: 9px;
    line-height: 1.2;
  }
  .f-ticket__qr_vs strong {
    text-align: center;
    display: block;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 2px;
  }
  .f-ticket__qr_tribuna {
    margin-top: 3px;
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    font-weight: 700;
  }
  .f-ticket__qr_tribuna .tline {
    width: 50%;
    padding-left: 5px;
    border-left: 1px solid #000;
  }
  .f-ticket__qr_tribuna > div {
    padding: 2px 0;
  }
  .f-ticket__qr_tribuna small {
    display: block;
    font-weight: 600;
  }
  .f-ticket__qr_sector {
    font-size: 11px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #000;
  }
  .f-ticket__qr_info {
    font-size: 6px;
    text-align: justify;
    margin-top: 5px;
  }
  .f-ticket__body {
    flex-shrink: 0;
    width: 435px;
    position: relative;
    z-index: 9;
  }
  .f-ticket__body_ruc {
    text-transform: uppercase;
    text-align: center;
    font-weight: 400;
    font-size: 10px;
    display: block;
    width: 305px;
    position: absolute;
    left: 0;
    bottom: 0;
    -webkit-transform-origin: left bottom;
            transform-origin: left bottom;
    -webkit-transform: rotate(-90deg) translateY(25px);
            transform: rotate(-90deg) translateY(25px);
  }
  .f-ticket__body_sure {
    position: absolute;
    left: 40px;
    font-size: 9px;
    font-weight: 500;
    bottom: 18px;
  }
  .f-ticket__body_content {
    padding: 40px 20px 20px 40px;
  }
  .f-ticket__body_head {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
  }
  .f-ticket__body_stadium {
    text-transform: uppercase;
    font-size: 11px;
  }
  .f-ticket__body_stadium b {
    display: block;
  }
  .f-ticket__body_date {
    text-align: right;
  }
  .f-ticket__body_vs {
    margin-top: 15px;
  }
  .f-ticket__body_tribune {
    font-size: 14px;
    margin-top: 5px;
    display: flex;
  }
  .f-ticket__body_tribune b {
    text-transform: uppercase;
  }
  .f-ticket__body_logos {
    margin-top: 8px;
    text-align: right;
    display: -webkit-box;
    /* justify-content: space-between;
    align-items: center; */
    position: absolute;
    left: 40px;
    right: 20px;
    bottom: 16px;
  }
  .f-ticket__body_logos .ft-jn {
    position: relative;
    right: -7px;
  }
  .f-ticket__body_logos img{
    padding: 0 2px;
  }
  .f-ticket__info {
    flex-shrink: 0;
    position: relative;
    width: 100px;
    position: relative;
    z-index: 9;
  }
  .f-ticket__info_body {
    width: 305px;
    overflow: hidden;
    height: 100px;
    padding: 5px 20px;
    position: absolute;
    bottom: 0;
    -webkit-transform-origin: left bottom;
            transform-origin: left bottom;
    -webkit-transform: rotate(-90deg) translateY(100px);
            transform: rotate(-90deg) translateY(100px);
  }
  .f-ticket__info_footer {
    line-height: 1.1;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .f-ticket__info_stadium {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 11px;
  }
  .f-ticket__info_stadium span {
    font-weight: 400;
    display: block;
  }
  .f-ticket__info_price {
    font-size: 18px;
    font-weight: 600;
  }
  .f-ticket__info_price small {
    font-weight: 400;
    font-size: 12px;
    display: block;
  }
  .f-ticket__info_tribuna {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 12px;
    line-height: 1.1;
  }
  .f-ticket__info_tribuna > div {
    padding: 3px 0;
  }
  .f-ticket__info_tribuna .tribunaLg {
    font-size: 110%;
  }
  .f-ticket__barcode {
    flex-shrink: 0;
    position: relative;
    width: 75px;
  }
  .f-ticket__barcode_body {
    width: 305px;
    overflow: hidden;
    height: 100px;
    padding: 10px 20px;
    position: absolute;
    bottom: 0;
    -webkit-transform-origin: left bottom;
            transform-origin: left bottom;
    -webkit-transform: rotate(-90deg) translateY(100px);
            transform: rotate(-90deg) translateY(100px);
  }
  .f-ticket__barcode_head {
    font-size: 10px;
    display: flex;
    justify-content: space-between;
  }
  .f-ticket__barcode_data {
    font-weight: 600;
    text-transform: uppercase;
  }
  .f-ticket__barcode_price {
    font-weight: 600;
    font-size: 13px;
    line-height: 1.1;
  }
  .f-ticket__barcode_price small {
    font-weight: 400;
    display: block;
  }
  .f-ticket__barcode_footer {
    margin-top: 2px;
    font-size: 10px;
    font-weight: 600;
    line-height: 1.1;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .f-ticket__barcode_footer small {
    font-weight: 400;
    display: block;
  }
  .f-voucher {
      font-family: 'Arial';
      font-size: 14px;
      width: 500px;
      margin: 0 auto;
      position: relative;
      padding: 10px;
      border: 1px solid #000;
      margin-top: 20px;
      margin-bottom: 20px;
      flex-shrink: 0;
      page-break-after: always;
  }
  .f-voucher h2 {
      font-size: 16px;
      text-align: center;
      font-weight: bold;
  }
  .f-voucher table.items {
      border-bottom: 1px dashed #000;
  }
  .f-voucher table.items th {
      border-bottom: 1px solid #000;
  }
  .f-voucher table.items tr {
      height: 30px;
  }
  .f-voucher-qr {
      margin: 0 auto;
      width: 140px;
      margin-top: 30px;
      margin-bottom: 30px;
  }

</style>